module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-type2 mt-32"
  }, [_c('h3', {
    staticClass: "section-title"
  }, [_vm._v("공공마이데이터")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-section mt-16 mydata-info-section"
  }, [_c('ul', {
    staticClass: "mydata-example-wrapper type2"
  }, [(_vm.publicMyDataYn.L001) ? _c('li', [_vm._v("\n        " + _vm._s(_vm.publicMyDataYn.L001) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.publicMyDataYn.L007) ? _c('li', [_vm._v("\n        " + _vm._s(_vm.publicMyDataYn.L007) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.publicMyDataYn.L017) ? _c('li', [_vm._v("\n        " + _vm._s(_vm.publicMyDataYn.L017) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.publicMyDataYn.L022) ? _c('li', [_vm._v("\n        " + _vm._s(_vm.publicMyDataYn.L022) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.publicMyDataYn.L026) ? _c('li', [_vm._v("\n        " + _vm._s(_vm.publicMyDataYn.L026) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.publicMyDataYn.L268) ? _c('li', [_vm._v("\n        " + _vm._s(_vm.publicMyDataYn.L268) + "\n      ")]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "description bt-line"
  }, [_vm._v("\n    공공마이데이터 인증과정을 통해 각종 증빙서류들을 파일첨부없이 증빙합니다. "), _c('br'), _vm._v("\n    (4대 사회보험료 완납증명서, 사업자등록증명, 표준재무제표증명(개인), 주민등록표 등초본)\n  ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dbd7dc64"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/member/APP/PublicMydataSection.vue
// module id = 1520
// module chunks = 6